import { Container } from "../atoms/Container";
import { SunriseMark } from "../atoms/SunriseMark";
import { WaitlistEmailField } from "../atoms/WaitlistEmailField";

type SiteFinalCTAProps = {
  mobile?: boolean;
};

export function SiteFinalCTA({ mobile = false }: SiteFinalCTAProps) {
  const pad = mobile ? 24 : 96;
  return (
    <section
      style={{
        paddingTop: mobile ? 80 : 144,
        paddingBottom: mobile ? 64 : 96,
        borderTop: "0.5px solid var(--hairline)",
      }}
    >
      <Container pad={pad}>
        <div
          style={{
            maxWidth: 560,
            margin: "0 auto",
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            gap: mobile ? 24 : 32,
          }}
        >
          <div style={{ display: "flex", justifyContent: "center" }}>
            <SunriseMark size={32} />
          </div>
          <h3
            style={{
              margin: 0,
              fontFamily: "var(--display)",
              fontSize: mobile ? 24 : 28,
              lineHeight: 1.25,
              letterSpacing: "-0.018em",
              color: "var(--text)",
              fontWeight: 400,
              textAlign: "center",
            }}
          >
            We&apos;ll see you at the start line.
          </h3>
          <div style={{ marginTop: 4 }}>
            <WaitlistEmailField size="sm" source="final-cta" />
          </div>
        </div>
      </Container>
    </section>
  );
}
